import { environment } from '@env/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AttachUploadFileService {

  constructor(
    private http: HttpClient
  ) { }

  /**
   * Método encargado de obtener los tipos de dictamen desde el API
   */
  getAttachedFileFromApi(fileData: any): Observable<Blob> {
    const attachedFileURL = this._buildUrlApi(fileData);
    // console.log('url', attachedFileURL);
    // window.open(attachedFileURL, '_blank');

    return this.http
        .get(attachedFileURL, { responseType: 'blob' });
  }

  _buildUrlApi(fileData: any): string {
    const {idAsociado, nombreRepositorio, isExamen} = fileData;
    // Eg: /lasegunda-ml-api/exams/attachments?id=S1U9JW7R5Q1ZZ4WBP6M3&examen=147049
    return `${environment.apiUrl}estudios/attachments?fileId=${nombreRepositorio}&id=${idAsociado}&isExamen=${isExamen}`;
  }
}
